(() => {
  const SLIDER_SELECTOR = ".multicolumn.multicolumn--slider";

  const initSlider = (sliderEl) => {
    if (!sliderEl || sliderEl.swiper) return; // avoid double init
    if ((sliderEl.dataset.layout || "grid") !== "slider") return;

    // ✅ correct dataset keys
    const productsPerRow = Number(sliderEl.dataset.productsPerRow || 3);
    const productsPerRowMobile = 1;

    // If Swiper isn’t present, don’t crash
    if (typeof window.Swiper === "undefined") {
      console.warn(
        "[multicolumn] Swiper not found. Include swiper-bundle.min.js & .css"
      );
      return;
    }

    const slidesPerViewMobile = productsPerRowMobile;
    const slidesPerView576 = productsPerRow > 1 ? 2 : 1;
    const slidesPerView990 =
      productsPerRow > 2 ? slidesPerView576 + 1 : slidesPerView576;
    const slidesPerView1100 = productsPerRow >= 4 ? 4 : productsPerRow;
    const slidesPerView1360 = productsPerRow;

    const nextBtn = sliderEl.querySelector(
      ".heading-group__navigation-button-next"
    );
    const prevBtn = sliderEl.querySelector(
      ".heading-group__navigation-button-prev"
    );

    const paginationElement = sliderEl.querySelector(
      ".heading-group__pagination"
    );

    const sliderSettings = {
      slidesPerView: slidesPerViewMobile,
      slidesPerGroup: slidesPerViewMobile,
      spaceBetween: 0,
      speed: 800,
      allowTouchMove: true,
      mousewheel: { forceToAxis: true },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
        disabledClass: "swiper-button-disabled",
      },
      pagination: {
        el: paginationElement,
        type: "fraction",
      },
      breakpoints: {
        576: {
          slidesPerView: slidesPerView576,
          slidesPerGroup: slidesPerView576,
        },
        990: {
          slidesPerView: slidesPerView990,
          slidesPerGroup: slidesPerView990,
        },
        1100: {
          slidesPerView: slidesPerView1100,
          slidesPerGroup: slidesPerView1100,
        },
        1360: {
          slidesPerView: slidesPerView1360,
          slidesPerGroup: slidesPerView1360,
        },
      },
    };

    new Swiper(sliderEl, sliderSettings);
  };

  const destroySlider = (sliderEl) => {
    if (!sliderEl) return;
    if (sliderEl.swiper) sliderEl.swiper.destroy(true, true);
    sliderEl.querySelector(".swiper-wrapper")?.removeAttribute("style");
    sliderEl
      .querySelectorAll(".swiper-slide")
      .forEach((s) => s.removeAttribute("style"));
  };

  const mountAll = (root = document) => {
    root.querySelectorAll(SLIDER_SELECTOR).forEach(initSlider);
  };
  const unmountAll = (root = document) => {
    root.querySelectorAll(SLIDER_SELECTOR).forEach(destroySlider);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => mountAll());
  } else {
    mountAll();
  }

  document.addEventListener("shopify:section:load", (e) => mountAll(e.target));
  document.addEventListener("shopify:section:unload", (e) =>
    unmountAll(e.target)
  );


  const DURATION = 3000;

  function formatFinalNumber(value, decimals) {
    return decimals > 0
      ? value.toFixed(decimals)
      : value.toLocaleString();
  }

  function formatAnimatedNumber(value, decimals) {
    const multiplier = Math.pow(10, decimals);

    const displayValue =
      Math.floor(value * multiplier) / multiplier;

    return decimals > 0
      ? displayValue.toFixed(decimals)
      : displayValue.toLocaleString();
  }

  function initCounters() {
    const elements = document.querySelectorAll(
      '.multicolumn .subheading_num'
    );

    const items = [];

    elements.forEach(function (el) {
      const raw = el.textContent.trim().replace(/,/g, '');

      if (!/^\d+(?:\.\d+)?$/.test(raw)) return;

      const target = Number(raw);
      const decimals = raw.includes('.')
        ? raw.split('.')[1].length
        : 0;

      items.push({
        el,
        target,
        decimals
      });

      el.textContent = formatFinalNumber(0, decimals);
    });

    if (items.length === 0) return;

    let startTime;
    let hasStarted = false;

    function runAnimation(timestamp) {
      if (startTime === undefined) {
        startTime = timestamp;
      }

      const elapsed = timestamp - startTime;
      const progress = Math.min(elapsed / DURATION, 1);

      items.forEach(function (item) {
        if (progress >= 1) {
          item.el.textContent = formatFinalNumber(
            item.target,
            item.decimals
          );
        } else {
          const value = item.target * progress;

          item.el.textContent = formatAnimatedNumber(
            value,
            item.decimals
          );
        }
      });

      if (progress < 1) {
        requestAnimationFrame(runAnimation);
      }
    }

    const sections = document.querySelectorAll('.multicolumn');

    const observer = new IntersectionObserver(
      function (entries) {
        const isVisible = entries.some(function (entry) {
          return entry.isIntersecting;
        });

        if (!isVisible || hasStarted) return;

        hasStarted = true;
        observer.disconnect();

        requestAnimationFrame(runAnimation);
      },
      {
        threshold: 0.3
      }
    );

    sections.forEach(function (section) {
      observer.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCounters);
  } else {
    initCounters();
  }
})();
